/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Icon_NewspaperInputs */



/**
* | output |
* | --- |
* | "Newspaper" |
*
* @param {Agent_Builder_Icon_NewspaperInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_icon_newspaper = /** @type {((inputs?: Agent_Builder_Icon_NewspaperInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Icon_NewspaperInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitung")
	return /** @type {LocalizedString} */ ("Newspaper")
});